import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGain } from 'apis/SetGain';
import { setDirection } from 'apis/SetDirection';
import {
  getSingleDevice,
  updateSingleDevicePageSelectedDevice,
  updatePivotOverviewPageSingleSelectedDevice,
  updateEchoOverviewPageSelectedDevice
} from 'redux/actions';
import { TABLE_TYPES } from '../../utils';
import '../../RfController.css';

const RfControllerButtonRow = ({
  device,
  deviceType,
  newAzimuth,
  newElevation,
  newVUplinkGain,
  newHUplinkGain,
  newVDownlinkGain,
  newHDownlinkGain,
  gainInProgress,
  directionInProgress,
  hasError,
  clearInputState,
  handleActionInProgress,
  handleResetActionInputs
}) => {
  const dispatch = useDispatch();
  const page = useSelector((state) => state.page);

  const cancelButtonDisabled =
    device == null ||
    device.id == null ||
    device.connectionState === 'Disconnected' ||
    gainInProgress ||
    directionInProgress ||
    !(newAzimuth || newElevation || newVUplinkGain || newHUplinkGain || newVDownlinkGain || newHDownlinkGain);

  const applyButtonDisabled = cancelButtonDisabled || hasError;

  const updateDeviceData = useCallback(async () => {
    await dispatch(
      getSingleDevice(device.id, (result) => {
        if (page === 'SingleDevicePage') {
          dispatch(updateSingleDevicePageSelectedDevice(result));
        } else {
          if (deviceType === 'echo') {
            dispatch(updateEchoOverviewPageSelectedDevice(result));
          } else {
            dispatch(updatePivotOverviewPageSingleSelectedDevice(result));
          }
        }
      })
    );
  }, [dispatch, device, deviceType, page]);

  return (
    <div className="RfControllerButtonRow">
      <button
        className="RfControllerButton RfControllerCancelButton Global_RoundedButton"
        disabled={cancelButtonDisabled}
        onClick={() => {
          clearInputState();
        }}
      >
        Cancel
      </button>

      <button
        type="submit"
        name="RfControllerSumbitName"
        id="RfControllerSumbit"
        className="RfControllerButton RfControllerSubmitButton Global_RoundedButton"
        disabled={applyButtonDisabled}
        onClick={(e) => {
          e.preventDefault();
          window._mfq = window._mfq || [];
          window._mfq.push(['formSubmitAttempt', '#RfControllerForm']);

          const az = parseFloat(newAzimuth);
          const el = parseFloat(newElevation);

          const promises = [];
          if (!isNaN(az) || !isNaN(el)) {
            handleActionInProgress(TABLE_TYPES.DIRECTION, true);
            promises.push(
              setDirection({
                deviceId: device.id,
                direction: {
                  azimuth: isNaN(az) ? device.properties.reported.antenna_direction.beamAzimuth : az,
                  elevation: isNaN(el) ? device.properties.reported.antenna_direction.beamElevation : el * -1
                }
              }).then(async () => await updateDeviceData())
            );
          }

          if (newVUplinkGain || newHUplinkGain || newVDownlinkGain || newHDownlinkGain) {
            handleActionInProgress(TABLE_TYPES.GAIN, true);
            promises.push(
              setGain(
                device.id,
                parseFloat(newVUplinkGain),
                parseFloat(newHUplinkGain),
                parseFloat(newVDownlinkGain),
                parseFloat(newHDownlinkGain)
              ).then(() => updateDeviceData())
            );
          }

          Promise.all(promises).finally(() => {
            window._mfq = window._mfq || [];
            window._mfq.push(['formSubmitSuccess', '#RfControllerForm']);

            dispatch(
              getSingleDevice(device.id, () => {
                handleResetActionInputs();
              })
            );
          });
        }}
      >
        Apply
      </button>
    </div>
  );
};

export default RfControllerButtonRow;
